import { Link } from "react-router";
import { GameVer, tturl, useRealm } from "~/util/Lang";

export function ClassLink(props: {
  prof: { name: string; profName: string; gver?: GameVer };
}) {
  const prof = props.prof;
  const realm = useRealm();

  return (
    <Link
      to={tturl(
        { lang: realm.lang, game: prof.gver ?? realm.game },
        "/classes/" + prof.profName,
      )}
    >
      {getName(prof.name)}
    </Link>
  );
}

function getName(name: string) {
  switch (name) {
    case "fighter":
      return "Fighter";
    case "mage":
      return "Mage";
    case "elven_fighter":
      return "Elven Fighter";
    case "elven_mage":
      return "Elven Mage";
    case "dark_fighter":
      return "Dark Fighter";
    case "dark_mage":
      return "Dark Mage";
    case "orc_fighter":
      return "Orc Fighter";
    case "orc_mage":
      return "Orc Mage";
    case "dwarven_fighter":
      return "Dwarven Fighter";

    // Human
    case "warrior":
      return "Warrior";
    case "knight":
      return "Knight";
    case "rogue":
      return "Rogue";
    case "wizard":
      return "Wizard";
    case "cleric":
      return "Cleric";

    // Elf
    case "elven_knight":
      return "Elven Knight";
    case "elven_scout":
      return "Elven Scout";
    case "elven_wizard":
      return "Elven Wizard";
    // TODO: elven oracle

    // Dark Elf
    case "palus_knight":
      return "Palus Knight";
    case "assassin":
      return "Assassin";
    case "dark_wizard":
      return "Dark Wizard";
    case "shillien_oracle":
      return "Shillien Oracle";

    // Orc
    case "orc_raider":
      return "Orc Raider";
    case "orc_monk":
      return "Monk";
    case "orc_shaman":
      return "Orc Shaman";

    // Dwarf
    case "artisan":
      return "Artisan";
    case "scavenger":
      return "Scavenger";
  }
  return name;
}
